export const transportData = {
    order: 9,
    name: 'transport',
    title: 'Transport',
    iconSrc: 'pic_transport.svg',
    headlineText: 'Ciągle jesteśmy w ruchu, a ekologia i transport też mogą iść w parze!',
    mainText:
        'Przemysł motoryzacyjny to jedna z najważniejszych gałęzi przemysłu. Tak olbrzymie upowszechnienie pojazdów spalinowych powoduje jednak, że rośnie również zapotrzebowanie na paliwo. Wiąże się to z coraz większą emisją spalin oraz intensywniejszym wydobyciem ropy, a wraz z wyczerpywaniem się jej światowych zasobów rośnie jej cena rynkowa. Może więc, zanim wsiądziemy do samochodu, warto się zastanowić czy trasa, którą mamy do pokonania, rzeczywiście wymaga uruchomienia silnika?',
    mainVideoSrc: '',
    odpadySection: [],
    klimatSection: [],
    energiaSection: [],
    powietrzeSection: [
        {
            text:
                'Zamiast korzystać z samochodu, wsiądź na rower, zrób sobie spacer lub skorzystaj z komunikacji miejskiej.',
        },
        {
            text:
                'W mieście działa system rowerów miejskich - jeśli nie masz własnego, skorzystaj z wypożyczalni!',
        },
        {
            text:
                'Wbrew pozorom polska komunikacja jest bardzo dobrze rozwinięta! Zbadaj rozkład autobusów w okolicy, sprawdź, gdzie są najbliższe przystanki oraz dworzec kolejowy i na następny wypad do lub poza miasto wybierz się autobusem, pociągiem lub tramwajem.',
        },
        {
            text:
                'Na krótkich dystansach sprawdzą się coraz popularniejsze pojazdy elektryczne – hulajnogi czy rowery wspomagane silnikami elektrycznymi.',
        },
        {
            text:
                'Warto zainwestować w samochody elektryczne lub hybrydowe, gdyż są przyjazne dla środowiska - i portfela! Parkingi dla właścicieli takich samochodów są w Jastrzębiu-Zdroju darmowe. Wystarczy posiadać kartę parkingową pojazdu napędzanego hybrydowo lub elektrycznie.',
        },
        {
            text: 'W Mieście działa także kilka ładowarek dla samochodów o napędzie elektrycznym.',
        },
        {
            text:
                'Carpooling – gdy już korzystasz z samochodu, np. aby dojechać do pracy, upewnij się, czy twoi współpracownicy również nie pokonują każdego dnia tej samej trasy. Jeżdżąc razem, wspólnie zadbacie o środowisko.',
        },
        {
            text:
                'Eco-driving, czyli ekojazda to podróżowanie samochodem w sposób ekonomiczny i ekologiczny, dzięki czemu ograniczamy ilość paliwa zużywanego podczas jazdy.',
        },
    ],
    wodaSection: [
        {
            text: 'Wybierz myjnię samochodową zamiast węża ogrodowego.',
        },
        {
            text: '',
            picSrc: 'pics/pic-21.png',
            caption:
                'Stan wód na świecie pogarsza się w związku z urbanizacją, rozwojem przemysłu i rolnictwa oraz wzrostem liczby ludności.',
        },
    ],
    czyWieszSection: [
        {
            text:
                '...w ciągu całego swojego życia ponad cztery lata spędzasz za kierownicą samochodu?...',
            more:
                'Dokładnie tyle zajęłaby podróż na Księżyc i z powrotem. Skoro więc aż tyle czasu jesteśmy w drodze, warto zainwestować w samochód, który będzie jak najbardziej przyjazny środowisku i zadbać o niego w taki sam sposób. ',
        },
        {
            text:
                '...samodzielne mycie samochodu wężem ogrodowym to nawet 300-400 litrów wylanej wody i mnóstwo chemikaliów w glebie?... ',
            more:
                'Lepiej więc umyć samochód na myjni automatycznej, która zużywa jedynie 150 litrów wody.' +
                '<br /><br /><a target="_blank" rel="noopener noreferrer" href="https://ulicaekologiczna.pl/technologie/czysto-czysciej%E2%80%A6-ekologiczne-myjnie-samochodowe">https://ulicaekologiczna.pl/technologie/czysto-czysciej%E2%80%A6-ekologiczne-myjnie-samochodowe</a>',
        },
        {
            text:
                '...cząstki stałe PM, czyli produkty wydostające się z układu wylotowego silnika zawierające m.in. pewną ilość cząstek węgla, związków siarki i azotu, metali oraz ciężkich węglowodorów, długo utrzymują się w atmosferze i są łatwo wchłanialne przez organizm?...',
            more:
                'Najczęstszymi chorobami powodowanymi przez spaliny samochodowe są: astma, przewlekłe choroby płuc, stany zapalne dróg oddechowych, nowotwory, choroby serca oraz układu nerwowego.',
        },
        {
            text: '...do spalania paliwa niezbędny jest tlen?...',
            more:
                'Szacuje się, że człowiek zużywa w ciągu godziny 30 litrów tlenu, natomiast samochód - 6000 litrów. Skoro jedno drzewo produkuje średnio 1200 litrów tlenu na godzinę, to na jeden samochód musi pracować 6 drzew. Jeden samochód zabiera więc tlen 200 osobom!',
        },
        {
            text:
                '...w Jastrzębiu dzieci, młodzież i studenci korzystają z komunikacji miejskiej za darmo?',
            more: '',
        },
        {
            text: '… Jastrzębie-Zdrój wspiera przesiadkę na rowery?...',
            more:
                'W mieście powstało 200 kilometrów tras i szlaków rowerowych. Na ich rozbudowę i budowę nowych przeznaczono 8,7 mln zł!',
        },
    ],
};
